import { parseQuery } from '@calendly/http-tools';
import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
const buttonSelectedCss = "b17h3srt";
const buttonHasCustomThemeCss = "b1tl63kd";
const buttonHiddenCss = "bgze5oh";
const buttonBookableCss = "b1u077fr";
const buttonHasSelectedSpotsCss = "bhsf2y0";
const buttonDiagnosticsCss = "b1d6ueg4";
const buttonCss = "bx4k40w";
const Button = forwardRef((props, ref) => {
  const {
    selected,
    hasCustomTheme,
    hidden,
    bookable,
    hasSelectedSpots,
    diagnostics,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(buttonCss, {
    [buttonSelectedCss]: selected,
    [buttonHasCustomThemeCss]: hasCustomTheme,
    [buttonHiddenCss]: hidden,
    [buttonBookableCss]: bookable,
    [buttonHasSelectedSpotsCss]: hasSelectedSpots,
    [buttonDiagnosticsCss]: diagnostics
  }, props.className)} />;
});
const dotBoldCss = "dihtas1";
const dotCss = "d1bg6viu";
const Dot = forwardRef((props, ref) => {
  const {
    bold,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dotCss, {
    [dotBoldCss]: bold
  }, props.className)} />;
});
const Day = ({
  children,
  bookable,
  today,
  selected,
  hasSelectedSpots,
  hidden = false,
  diagnostics = false,
  ...restProps
}) => {
  const theme = parseQuery(window.location.search);
  const customThemeAllowed = useSelector(state => state.custom_theme_allowed);
  return <td role="gridcell" aria-disabled={bookable ? null : true} aria-selected={bookable ? selected : null}>
      <Button aria-current={today ? 'date' : null} bookable={bookable} selected={selected} hasSelectedSpots={hasSelectedSpots} hidden={hidden} diagnostics={diagnostics} hasCustomTheme={customThemeAllowed && Boolean(theme.primary_color)} {...restProps}>
        <span>{children}</span>
        {today && <Dot bold={bookable || selected} data-component="today-dot" />}
      </Button>
    </td>;
};
Day.propTypes = {
  children: PropTypes.node.isRequired,
  bookable: PropTypes.bool.isRequired,
  today: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  hasSelectedSpots: PropTypes.bool,
  hidden: PropTypes.bool,
  diagnostics: PropTypes.bool
};
export default Day;

require("./day.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./day.js");